import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ThemeService } from '../../services/theme.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit {
  themeList: any;
  signInLabel: string;
  usernamePlaceholder: string;
  passwordPlaceholder: string;
  signUpButtonLabel: string;
  noAccountLabel: string;
  forgotPasswordButtonLabel: string;
  pleaseSignInMessage: string;
  signUpLabel: string;
  signInButtonLabel: string;
  haveAccount: string;
  
  user: any;

  constructor(public authService: AuthService, private themeService: ThemeService) {
    this.themeService.getAuthorizationSettings().once('value', snapshot => {
      this.signInLabel = snapshot.val().sign_in_label;
      this.usernamePlaceholder = snapshot.val().username_placeholder;
      this.passwordPlaceholder = snapshot.val().password_placeholder;
      this.signUpButtonLabel = snapshot.val().sign_up_button_label;
      this.noAccountLabel = snapshot.val().no_account_label;
      this.forgotPasswordButtonLabel = snapshot.val().forgot_password_button_label;
      this.pleaseSignInMessage = snapshot.val().please_sign_in;
      this.signUpLabel = snapshot.val().sign_up_label;
      this.signInButtonLabel = snapshot.val().sign_in_button_label;
      this.haveAccount = snapshot.val().have_account;
    });
  }

  ngOnInit() {}

  registerUser(username, email, password, firstname, lastname){
    //this.authService.registerJoomlaUser(email, password, firstname, lastname, username).subscribe((event: HttpEvent<any>) => {
      this.authService.SignUp(email, password, firstname, lastname, username);
      // switch (event.type) {
      //   case HttpEventType.Sent:
      //     console.log('Request sent!');
      //     break;
      //   case HttpEventType.ResponseHeader:
      //     console.log('Response header received!');
      //     break;
      //   case HttpEventType.DownloadProgress:
      //     const kbLoaded = Math.round(event.loaded / 1024);
      //     console.log(`Download in progress! ${kbLoaded}Kb loaded`);
      //     break;
      //   case HttpEventType.Response:
      //     console.log('😺 Done!', event.body);
      //     this.user = event.body;
      // }
    //});
  }
}
